<template>
  <v-dialog v-model="dialog" width="500" persistent >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-title class="red--text"
          >Cancel Subscription</v-list-item-title
        >
      </v-list-item>
    </template>

    <v-card class="rounded-xl">
      <v-card-title class="headline" primary-title>
        Cancel Subscription
      </v-card-title>
      <v-card-text>
        <div>
          <!-- <strong>Subscription End</strong> <br />
            <span v-if="subscription">{{
              $moment.unix(subscription.current_period_end).format("MMM DD, YYYY")
            }}</span> -->
          <div>
            Cancelling subscription will stop future charege, you can continue
            use the service that you paid for till
            <strong>{{
              $moment
                .unix(subscription.current_period_end)
                .format("MMM DD, YYYY")
            }}</strong>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="dialog = false" color="success">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn small @click="cancelSub" color="primary"
          >Cancel Subscription</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import locationService from "@/modules/Location/service.js";
export default {
  name: "cancel-subscription",
  props: ["subscription", "customer", "upComingInvoice", "location"],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    cancelSub() {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            locationService.Billing.cancelPlan(this.location.id).then(
              (response) => {
                console.log('response', response)
               this.$toast.success("Subscripation was cancelled!", {
                  timeout: 2000,
                });
                this.$emit('subCancel')
                this.dialog = false
              }
            );
            // employeeService.delete(employee.id).then((response) => {
            //   if (response.data) {
            //     this.$toast.success("Employee has been deleted", {
            //       timeout: 2000,
            //     });

            //     this.getAll();
            //   }
            // });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
  },
};
</script>

<style scoped>
</style>